export default {
    title: "顾问建议",
    noItems: "没有推荐"
}